module.exports = __webpack_public_path__ + "img/info-inner01.ec71eb7b.png";